import { Link, useParams } from "react-router";
import { useServices } from "../app/services";
import { useResource } from "../app/useResource";
import { PostCard } from "../components/cards";
import { PageHeader, ResourceView } from "../components/ui";

export function PostPage() {
  const { id = "" } = useParams();
  const { api } = useServices();
  const res = useResource("posts.get", () => api.getPost(id), [id], ["posts", "library"]);
  // 公開取り消し・削除後に、古い本文を残さない。
  const resource = res.status === "ready" && res.refreshError
    ? { status: "error" as const, error: res.refreshError, reload: res.reload } : res;
  return (
    <div className="page page--narrow">
      <PageHeader title={resource.status === "ready" && resource.data.moments?.length ? "ここ好き" : "投稿"} lead="好きな瞬間を、おすそわけ。" />
      <ResourceView resource={resource} what="投稿">
        {(post) => <ul className="post-list post-list--detail"><PostCard post={post} showVisibility detail /></ul>}
      </ResourceView>
      <p className="section-more"><Link className="btn btn-ghost" to="/posts">みんなの投稿へ</Link></p>
    </div>
  );
}
